// src/context/ShopModeContext.jsx
import React, { createContext, useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ShopModeContext = createContext();

export const ShopModeProvider = ({ children }) => {
  const [mode, setMode] = useState("garment"); // или 'web3'
  const location = useLocation();

  useEffect(() => {
    const { pathname, search } = location;

    // 1) Если мы находимся на странице товара (ShopItem/ProductDetails),
    //    то просто ничего не меняем — так мы сохраняем тот режим, который
    //    установил ProductDetails через setMode(...)
    if (pathname.startsWith("/shop/item")) {
      return;
    }

    // 2) Явный переход на /shop/web3 – переключаем в web3
    if (pathname.startsWith("/shop/web3")) {
      setMode("web3");
      return;
    }

    // 3) Явный переход на /shop/garment – переключаем в garment
    if (pathname.startsWith("/shop/garment")) {
      setMode("garment");
      return;
    }

    // 4) Если мы в каталоге: /shop/catalog?category=..., смотрим параметр category
    if (pathname.startsWith("/shop/catalog")) {
      const params = new URLSearchParams(search);
      const category = params.get("category");
      // Перечислите здесь те категории, которые относятся к Web3-блоку:
      const web3Categories = ["diamonds", "skins", "subscriptions", "codes"];
      if (category && web3Categories.includes(category)) {
        setMode("web3");
      } else {
        setMode("garment");
      }
      return;
    }

    // 5) Во всех остальных случаях (например, просто /shop или неизвестный path) — оставляем garment
    setMode("garment");
  }, [location.pathname, location.search]);

  return (
    <ShopModeContext.Provider value={{ mode, setMode }}>
      {children}
    </ShopModeContext.Provider>
  );
};

export const useShopMode = () => useContext(ShopModeContext);